import { render, staticRenderFns } from "./DeleteNews.vue?vue&type=template&id=016b6cd3&"
import script from "./DeleteNews.vue?vue&type=script&lang=js&"
export * from "./DeleteNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports